// Time-based Matrix mode detection utility

/**
 * Check if current time is within Matrix hours (11 PM - 3 AM)
 * @returns {boolean} True if it's Matrix time
 */
export const isMatrixTime = () => {
  const now = new Date();
  const hour = now.getHours();
  
  // Matrix hours: 23:00 (11 PM) to 02:59 (3 AM)
  return hour >= 23 || hour < 3;
};

/**
 * Check if it's a special Matrix date
 * @returns {boolean} True if it's a special Matrix date
 */
export const isSpecialMatrixDate = () => {
  const now = new Date();
  const month = now.getMonth() + 1; // getMonth() returns 0-11
  const day = now.getDate();
  
  // Friday the 13th
  if (day === 13 && now.getDay() === 5) {
    return true;
  }
  
  // April 1st (April Fools)
  if (month === 4 && day === 1) {
    return true;
  }
  
  return false;
};

/**
 * Check for leet time (13:37)
 * @returns {boolean} True if it's 1:37 PM
 */
export const isLeetTime = () => {
  const now = new Date();
  const hour = now.getHours();
  const minute = now.getMinutes();
  
  return hour === 13 && minute === 37;
};

/**
 * Random Matrix glitch (1% chance)
 * @returns {boolean} True if random glitch occurs
 */
export const isRandomMatrixGlitch = () => {
  return Math.random() < 0.01; // 1% chance
};

/**
 * Main function to determine if Matrix mode should be active
 * @returns {object} Matrix mode status and reason
 */
export const getMatrixModeStatus = () => {
  if (isLeetTime()) {
    return {
      isActive: true,
      reason: 'leet',
      message: 'You found the code at 13:37',
    };
  }
  
  if (isSpecialMatrixDate()) {
    return {
      isActive: true,
      reason: 'special_date',
      message: 'Special Matrix day detected',
    };
  }
  
  if (isMatrixTime()) {
    return {
      isActive: true,
      reason: 'night_hours',
      message: 'The Matrix never sleeps',
    };
  }
  
  if (isRandomMatrixGlitch()) {
    return {
      isActive: true,
      reason: 'glitch',
      message: 'Glitch in the Matrix detected',
    };
  }
  
  return {
    isActive: false,
    reason: 'normal',
    message: 'Normal operation',
  };
};

/**
 * Get Matrix-themed message based on current time
 * @returns {string} Time-appropriate Matrix message
 */
export const getMatrixTimeMessage = () => {
  const hour = new Date().getHours();
  
  if (hour >= 23 || hour < 1) {
    return "The Matrix never sleeps, Neo...";
  } else if (hour >= 1 && hour < 3) {
    return "Deep in the rabbit hole now...";
  } else if (hour === 13) {
    return "The chosen hour approaches...";
  } else {
    return "Welcome to the real world.";
  }
};

